"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategorySorting = void 0;
var CategorySorting;
(function (CategorySorting) {
    CategorySorting["Alphabetical"] = "alpha";
    CategorySorting["Default"] = "";
    CategorySorting["Recency"] = "recent";
    CategorySorting["Manual"] = "manual";
})(CategorySorting || (exports.CategorySorting = CategorySorting = {}));
